<template>
    <v-card>
        <v-card-title>会員{{ pageTitle }}</v-card-title>
        <v-card class="mx-3" outlined>
            <v-card-title>基本情報</v-card-title>
            <v-card-text>
                <v-form @submit="post" @submit.prevent v-model="valid">
                    <v-container>
                        <v-row dense>
                            <v-col cols="6" sm="3" lg="2">
                                <v-select
                                    label="支店"
                                    v-model="customer.shop_id"
                                    :items="shops"
                                    :rules="rules.shop_id"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" lg="2">
                                <v-select
                                    label="フロント"
                                    v-model="customer.front_id"
                                    :items="fronts"
                                ></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" lg="2">
                                <v-select
                                    label="クローザー"
                                    v-model="customer.counselor_id"
                                    :items="counselors"
                                ></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" lg="2">
                                <v-select
                                    label="担当AD"
                                    v-model="customer.adviser_id"
                                    :items="advisers"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" lg="2">
                                <v-checkbox
                                    label="手紙送付"
                                    v-model="customer.valid_mail"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6" sm="3" lg="2">
                                <v-checkbox
                                    label="グレーゾーン"
                                    v-model="customer.is_grayzone"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" md="3" lg="2">
                                <v-text-field
                                    v-model="customer.family_name"
                                    label="姓"
                                    :counter="16"
                                    :rules="rules.family_name"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3" lg="2">
                                <v-text-field
                                    v-model="customer.given_name"
                                    label="名"
                                    :counter="16"
                                    :rules="rules.given_name"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3" lg="2">
                                <v-text-field
                                    v-model="customer.family_name_kana"
                                    label="せい"
                                    :counter="16"
                                    :rules="rules.family_name_kana"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3" lg="2">
                                <v-text-field
                                    v-model="customer.given_name_kana"
                                    label="めい"
                                    :counter="16"
                                    :rules="rules.given_name_kana"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" md="2">
                                <v-select
                                    label="性別"
                                    v-model="customer.gender"
                                    :items="CUSTOMER.GENDER.LIST"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col cols="3" md="2">
                                <v-select
                                    label="血液型"
                                    v-model="customer.blood_type"
                                    :items="CUSTOMER.BLOOD_TYPE.LIST"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col cols="7" md="4" lg="3">
                                <v-menu
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="customer.birthday"
                                            label="生年月日"
                                            persistent-hint
                                            v-bind="attrs"
                                            :rules="rules.birthday"
                                            @blur="date = parseDate(customer.birthday)"
                                            v-on="on"
                                            width="120px"
                                        >
                                            <template v-slot:append>
                                                {{calcAge(customer.birthday)}}歳
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date"
                                        :day-format="date => new Date(date).getDate()"
                                        no-title
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6" sm="4" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.phone_number"
                                    label="電話番号"
                                    :counter="16"
                                    :rules="rules.phone_number"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" lg="3">
                                <v-text-field
                                    v-model="customer.phone_number_home"
                                    label="自宅番号"
                                    :counter="16"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" lg="3">
                                <v-text-field
                                    v-model="customer.email_address"
                                    label="メールアドレス"
                                    :counter="64"
                                    :rules="rules.email_address"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" md="2" lg="1">
                                <v-text-field
                                    v-model="customer.zip"
                                    label="〒"
                                    :counter="8"
                                    :rules="rules.zip"
                                    required
                                >
                                    <template v-slot:append>
                                        <v-btn icon small outlined @click="getZip();"><v-icon small>mdi-magnify</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="4" md="2" lg="1">
                                <v-select
                                    label="県"
                                    v-model="customer.pref"
                                    :items="prefectures"
                                    :rules="rules.pref"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col cols="4" lg="3">
                                <v-text-field
                                    v-model="customer.address1"
                                    label="市区町村"
                                    :counter="48"
                                    :rules="rules.address1"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.address2"
                                    label="住所"
                                    :counter="48"
                                    :rules="rules.address2"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field
                                    v-model="customer.building_name"
                                    label="マンション等"
                                    :counter="48"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.sheet_id"
                                    label="旧カルテID"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.tel_enable_date"
                                    label="架電可能曜日"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.tel_enable_time"
                                    label="架電可能時間"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.holidays"
                                    label="休日"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.company_name"
                                    label="会社名"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.company_name_kana"
                                    :rules="rules.company_name_kana"
                                    label="会社名ーふりがな"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="2" lg="1">
                                <v-text-field
                                    v-model="customer.company_zip"
                                    label="〒"
                                    :counter="8"
                                >
                                    <template v-slot:append>
                                        <v-btn icon small outlined @click="getZip_company();"><v-icon small>mdi-magnify</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.company_address"
                                    label="会社住所"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.company_tel"
                                    label="勤務先電話番号"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.industry"
                                    label="業種"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.employment_years"
                                    label="勤続年数"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <v-text-field
                                    v-model="customer.income"
                                    label="年収"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="customer.line_link"
                                    label="LINEリンク"
                                    :rules="rules.line_link"
                                    placeholder="https://"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row dense>
                                    <v-col cols="12">
                                        <span class="font-weight-bold">連盟情報</span>
                                    </v-col>
                                    <v-col cols="6" md="4">
                                        <v-checkbox
                                            v-model="customer.connect_federation"
                                            label="コネクト"
                                            hide-details
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" md="4">
                                        <v-checkbox
                                            v-model="customer.ibj_federation"
                                            label="IBJ"
                                            hide-details
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="info"
                            type="submit"
                            :disabled="!valid"
                        >{{ pageTitle }}</v-btn>
                        <v-btn to="/customer/list">キャンセル</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="telDuplicate"
            timeout="2000"
        >
            電話番号が重複しています
            <template v-slot:action="{ attrs }">
                <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="telDuplicate = false"
                >
                閉じる
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"

export default {
    title() {
        if(this.$route.name === 'customer_add') return "会員追加";
        if(!this.customer) return "会員編集";

        let name = `${this.customer.family_name} ${this.customer.given_name}`;
        return `${name} (編集)`;
    },
    name: "customer_form",
    mixins: [utilDatetime],
    data: () => ({
        customer: {
            shop_id: null,
            counselor_id: 0,
            front_id: null,
            number: "",
            valid_mail: false,
            is_grayzone: false,
            family_name: "",
            given_name: "",
            family_name_kana: "",
            given_name_kana: "",
            gender: 1,
            blood_type: 10,
            birthday: "",
            phone_number: "",
            phone_number_home: "",
            tel_enable_date: "",
            tel_enable_time: "",
            holidays: "",
            company_name: "",
            company_name_kana: "",
            company_zip: "",
            company_address: "",
            company_tel: "",
            industry: "",
            employment_years: "",
            income: "",
            email_address: "",
            zip: "",
            pref: 0,
            address1: "",
            address2: "",
            building_name: "",
            sheet_id: "",
            line_link: "",
            connect_federation: false,
            ibj_federation: false,
        },
        telDuplicate: false,
        valid: false,
        shops: [],
        counselors: [],
        advisers: [],
        fronts: [],
        CUSTOMER: CUSTOMER,
        date: null,
        prefectures: [],
        rules: {
            shop_id: [
                (v) => !!v || "支店を選択してください",
            ],
            number: [
                (v) => v <= 99999999 || "会員ナンバーは8桁までです",
            ],
            family_name: [
                (v) => !!v || "姓を入れてください",
                (v) => v.length <= 16 || "姓は16文字までです",
            ],
            given_name: [
                (v) => !!v || "名を入れてください",
                (v) => v.length <= 16 || "名は16文字までです",
            ],
            family_name_kana: [
                (v) => !!v || "せいを入れてください",
                (v) => v.length <= 16 || "せいは16文字までです",
                (v) => /^[ぁ-ゞ]*$/.test(v) || "せいはひらがなで入力してください",
            ],
            given_name_kana: [
                (v) => !!v || "めいを入れてください",
                (v) => v.length <= 16 || "めいは16文字までです",
                (v) => /^[ぁ-ゞ]*$/.test(v) || "めいはひらがなで入力してください",
            ],
            company_name_kana: [
                (v) => v.length <= 32 || "会社名ーふりがなは32文字までです",
                (v) => /^[ぁ-ゞー\s]*$/.test(v) || "ひらがなで入力してください",
            ],
            birthday: [
                (v) => !!v || "生年月日を入力してください",
            ],
            phone_number: [
                (v) => !!v || "電話番号を入力してください",
            ],
            email_address: [
                (v) => (v == null || v.length <= 64) || "メールアドレスは64文字までです",
            ],
            zip: [
                (v) => !!v || "郵便番号を入力してください",
                (v) => v.length == 8 || "郵便番号はハイフンありで8文字で入力してください",
            ],
            pref: [
                (v) => !!v || "県を選択してください",
            ],
            address1: [
                (v) => !!v || "市区町村を入力してください",
            ],
            address2: [
                (v) => !!v || "住所を入力してください",
            ],
            line_link: [
                (v) => !v || v.startsWith('https://') || "LINEリンクはhttps://から始まる必要があります",
            ],
        },
    }),
    computed: {
        pageTitle() {
            return this.$route.name === 'customer_add' ? "追加" : "編集";
        }
    },
    watch: {
        date () {
            this.customer.birthday = this.formatDate(this.date);
        }
    },
    async mounted() {
        await this.loadInit();
    },
    methods: {
        async loadInit() {
            const id = (this.$route.name === 'customer_add' ? '' : (this.$route.params.id));
            try {
                const result = await this.$axios
                    .get(`/api/v1/customer/form/${id}`)
                    .then((response) => {
                        return response.data;
                    })
                    .catch((error) => {
                        return error;
                    });

                if (result) {
                    if(this.$route.name === 'customer_edit') {
                        this.customer = result.customer;
                    }
                    this.shops = result.shops;
                    this.counselors = result.counselors;
                    this.counselors.push({ value: 0, text: "未定" })
                    this.advisers = result.advisers;
                    this.advisers.push({ value: 0, text: "未定" })
                    this.fronts = result.fronts || result.counselors; // Use counselors as fronts for now
                    this.fronts.push({ value: null, text: "未定" })
                    this.prefectures = result.prefectures;
                }
                this.setTitle()
            } catch (error) {
                console.log(error);
            }
        },
        async getZip() {
            const zip = this.customer.zip.replace(/[^\d]+/g, '');
            await this.$axios
                .get("/api/v1/postcode", {
                    params: { zip }
                })
                .then(response => {
                    const addressData =  response.data;
                    this.customer.pref = addressData.prefecture_id;
                    this.customer.address1 = addressData.address1;
                    this.customer.address2 = addressData.address2;
                })
                .catch(error=>{
                    console.log(error)
                });
        },
        async getZip_company() {
            const zip = this.customer.company_zip.replace(/[^\d]+/g, '');
            await this.$axios
                .get("/api/v1/postcode", {
                    params: { zip }
                })
                .then(response => {
                    const addressData =  response.data;
                    this.customer.company_address = addressData.address1 + addressData.address2;
                })
                .catch(error=>{
                    console.log(error)
                });
        },
        async post() {
            const customerInfo = {
                shop_id: this.customer.shop_id,
                counselor_id: this.customer.counselor_id,
                front_id: this.customer.front_id,
                adviser_id: this.customer.adviser_id,
                number: this.customer.number,
                valid_mail: this.customer.valid_mail,
                is_grayzone: this.customer.is_grayzone,
                family_name: this.customer.family_name,
                given_name: this.customer.given_name,
                family_name_kana: this.customer.family_name_kana,
                given_name_kana: this.customer.given_name_kana,
                gender: this.customer.gender,
                blood_type: this.customer.blood_type,
                birthday: this.customer.birthday,
                phone_number: this.customer.phone_number,
                phone_number_home: this.customer.phone_number_home,
                tel_enable_date: this.customer.tel_enable_date,
                tel_enable_time: this.customer.tel_enable_time,
                holidays: this.customer.holidays,
                company_name: this.customer.company_name,
                company_name_kana: this.customer.company_name_kana || "",
                company_zip: this.customer.company_zip,
                company_address: this.customer.company_address,
                company_tel: this.customer.company_tel,
                industry: this.customer.industry,
                employment_years: this.customer.employment_years,
                income: this.customer.income,
                email_address: this.customer.email_address,
                zip: this.customer.zip,
                pref: this.customer.pref,
                address1: this.customer.address1,
                address2: this.customer.address2,
                building_name: this.customer.building_name,
                sheet_id: this.customer.sheet_id,
                line_link: this.customer.line_link,
                connect_federation: this.customer.connect_federation,
                ibj_federation: this.customer.ibj_federation
            };
            if(this.$route.name === 'customer_add') {
                // 電話番号チェック
                const isDuplicate = await this.$axios
                    .get(`/api/v1/customer/duplicate_tel/${this.customer.phone_number}`)
                    .then((response) => {
                        return response.data.result;
                    })
                    .catch((error) => {
                        return error;
                    }); 
                if(isDuplicate) {
                    this.telDuplicate = true;
                    return;
                }
                
                await this.$axios
                    .post("/api/v1/customer", { customerInfo })
                    .catch((error) => {
                        console.log("Error : " + error);
                    })
                    .then((response) => {
                        if(response.data.result) {
                            alert("会員の登録に失敗しました。\n登録内容に間違いがないか確認してください。");
                            return;
                        }
                        console.log("Created : id=" + response.data.id);
                        this.$router.push(`/customer/list`)
                    })
            } else {
                await this.$axios
                    .put(`/api/v1/customer/${this.$route.params.id}`, { customerInfo })
                    .catch((error) => {
                        console.log("Error : " + error);
                    })
                    .then((response) => {
                        console.log("Edited : id=" + response.data.id);
                        this.$router.push(`/customer/list`)
                    })
            }
        },
        formatDate (date) {
            if (!date) return null

            try {
                const [year, month, day] = date.split('-')
                return `${year}/${month}/${day}`
            } catch {
                return null;
            }
        },
        parseDate (date) {
            if (!date) return null

            try{
                const [year, month, day] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            } catch {
                return null;
            }
        },
    },
};
</script>
